import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "panel__header" }
const _hoisted_2 = {
  key: 0,
  class: "panel__header--icon"
}
const _hoisted_3 = { class: "panel__header--label" }
const _hoisted_4 = { class: "panel__body" }

import {Component} from "vue";

interface IPanel {
  label: string;
  icon?: Component;
  number: number;
  type?: "error" | "default";
  size?: "small" | "large";
  isActive: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomPanel',
  props: {
    label: { default: "" },
    icon: {},
    number: {},
    type: { default: "default" },
    size: { default: "small" },
    isActive: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-cu-panel", [__props.size, __props.type, { active: __props.isActive }]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.icon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), { size: 20 }))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(__props.label), 1)
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(__props.number), 1)
  ], 2))
}
}

})